export default {
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  type: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  date: {
    value: '',
    maxlength: '30',
    required: true,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/holiday/holiday-form.js